import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiToast } from '@hooks/useApiToast';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';

type DeleteWorkOrderDocumentParams = {
  jobNumber: string;
  documentCompany: string;
  documentName: string;
};

export const useDeleteWorkOrderDocument = () => {
  const queryClient = useQueryClient();
  const { showError } = useApiToast();
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useMutation<void, Error, DeleteWorkOrderDocumentParams>({
    mutationFn: async ({ jobNumber, documentCompany, documentName }) => {
      await workOrdersApi.apiWorkOrdersJobNumberDocumentsDocumentCompanyDocumentNameDelete(
        {
          jobNumber,
          documentCompany,
          documentName
        }
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['workorders', 'documents', variables.jobNumber]
      });
    },
    onError: error => {
      showError(
        'customerAcknowledgment.deleteSignatureFailed',
        error,
        'customerReview'
      );
    }
  });
};
